import React from "react";

import { Grid, MenuItem, MenuList, Paper } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

export const AdminHomeLayout = React.memo(function AdminHomeLayout({
  children,
}) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const LINKS = [
    {
      url: "/admin/users",
      label: t("admin-users"),
    },
    {
      url: "/admin/question",
      label: t("admin-questions"),
    },
    {
      url: "/admin/audio-donations",
      label: t("admin-audio-donations"),
    },
    {
      url: "/admin/dataset",
      label: t("admin-audio-dataset"),
    },
  ];

  return (
    <Grid container spacing={2}>
      <Grid item md={4} xs={12}>
        <Paper>
          <MenuList>
            {LINKS.map(({ url, label }) => (
              <MenuItem
                key={url}
                button
                selected={window.location.pathname.startsWith(url)}
                onClick={() => {
                  navigate(url);
                }}
              >
                {label}
              </MenuItem>
            ))}
          </MenuList>
        </Paper>
      </Grid>
      <Grid item md={8} xs={12}>
        <Paper>{children}</Paper>
      </Grid>
    </Grid>
  );
});
